import { memo } from "react";

import classnames from "classnames";
import withT from "neetocommons/react-utils/withT";
import { Typography } from "neetoui";
import PropTypes from "prop-types";

import ScreenSizeImage from "assets/images/screen-size";

const DeviceIncompatibilityMessage = withT(
  ({ t, className = "", description = "" }) => (
    <div
      className={classnames(
        "mx-auto flex w-full max-w-80 flex-col items-center justify-center p-4",
        className
      )}
    >
      <ScreenSizeImage />
      <Typography
        className="neeto-ui-text-center mt-6"
        data-testid="device-incompatibility-description"
        style="body2"
      >
        {description || t("neetoMolecules.deviceIncompatibility.description")}
      </Typography>
    </div>
  )
);

DeviceIncompatibilityMessage.propTypes = {
  /**
   * Additional classes to be added to the modal.
   */
  className: PropTypes.string,
  /**
   * To provide description.
   */
  description: PropTypes.node,
};

export default memo(DeviceIncompatibilityMessage);
